module.exports = __webpack_public_path__ + "img/MASTER_CHN_VP_Handbook_Web4.60d00ebb.jpg";